import { render, staticRenderFns } from "./diagram-box.vue?vue&type=template&id=a402c1a6&scoped=true"
import script from "./diagram-box.vue?vue&type=script&lang=js"
export * from "./diagram-box.vue?vue&type=script&lang=js"
import style0 from "./diagram-box.vue?vue&type=style&index=0&id=a402c1a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a402c1a6",
  null
  
)

export default component.exports